/* Essential 9 theme scripts */
(function(){
  var inDesignMode = window.Shopify && window.Shopify.designMode;

  // reveal on scroll
  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function(es){
    es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); } });
  }, {threshold:.12}) : null;

  function reveal(root){
    var els = (root||document).querySelectorAll('.reveal');
    els.forEach(function(el){
      // In the theme editor, or when observers aren't available, show immediately so
      // re-rendered sections are never left invisible.
      if(inDesignMode || !io){ el.classList.add('in'); return; }
      io.observe(el);
    });
  }
  reveal();
  // Safety net: guarantee everything is visible shortly after load no matter what.
  window.addEventListener('load', function(){ setTimeout(function(){ document.querySelectorAll('.reveal:not(.in)').forEach(function(el){
    var r = el.getBoundingClientRect();
    if(r.top < window.innerHeight + 200){ el.classList.add('in'); }
  }); }, 400); });

  // hero slideshow (images rotate, text stays fixed)
  function initHero(root){
    (root||document).querySelectorAll('[data-hero]').forEach(function(hero){
      if(hero.__init) return; hero.__init = true;
      var slides = hero.querySelectorAll('.hero-slide');
      var dots = hero.querySelectorAll('.hero-dots button');
      if(slides.length < 2) return;
      var i = 0, speed = parseInt(hero.getAttribute('data-speed')||'5000',10), timer;
      function show(n){ i=(n+slides.length)%slides.length; slides.forEach(function(s,x){ s.classList.toggle('on',x===i); }); dots.forEach(function(d,x){ d.classList.toggle('on',x===i); }); }
      function start(){ timer=setInterval(function(){ show(i+1); }, speed); }
      dots.forEach(function(d,x){ d.addEventListener('click', function(){ show(x); clearInterval(timer); start(); }); });
      start();
    });
  }
  initHero();

  // Product galleries use one handler per thumbnail button.
  function initGallery(root){
    (root||document).querySelectorAll('[data-gallery]').forEach(function(g){
      if(g.__e9GalleryInitialized) return;
      g.__e9GalleryInitialized = true;
      var main = g.querySelector('[data-main-img]');
      var buttons = g.querySelectorAll('.thumb-btn');
      buttons.forEach(function(button){
        button.addEventListener('click', function(){
          var thumb = button.querySelector('img');
          if(!main || !thumb || thumb.classList.contains('active')) return;
          var full = thumb.getAttribute('data-full') || thumb.src;
          main.removeAttribute('srcset');
          main.src = full;
          main.alt = thumb.alt;
          var previous = g.querySelector('.thumbs img.active');
          if(previous) previous.classList.remove('active');
          thumb.classList.add('active');
        });
      });
    });
  }
  initGallery();

  // global click handlers (menu, search, faq, quantity)
  document.addEventListener('click', function(e){
    if(e.target.closest('.js-menu-open')){ var m=document.querySelector('.mobile-menu'); if(m){ m.classList.add('open'); document.documentElement.classList.add('e9-mobile-menu-open'); } }
    if(e.target.closest('.js-menu-close') || e.target.classList.contains('mobile-menu')){ var m2=document.querySelector('.mobile-menu'); if(m2){ m2.classList.remove('open'); document.documentElement.classList.remove('e9-mobile-menu-open'); } }
    if(e.target.closest('.js-search-toggle')){
      var bar = document.querySelector('.search-bar');
      if(bar){ bar.hidden = !bar.hidden; if(!bar.hidden){ var inp = bar.querySelector('input[type=search]'); if(inp) inp.focus(); } }
    }
    var q = e.target.closest('.faq-q');
    if(q){ q.parentElement.classList.toggle('open'); }
    var b = e.target.closest('[data-qty]');
    if(b){
      var input = b.parentElement.querySelector('input');
      var v = parseInt(input.value||'1',10);
      input.value = b.getAttribute('data-qty')==='up' ? v+1 : Math.max(1, v-1);
    }
    if(e.target.closest('[data-sticky-add]')){
      var form = document.querySelector('form[data-product-form]');
      if(form){ var sb=form.querySelector('[type=submit]'); if(sb) sb.click(); }
    }
  });

  // Shopify theme editor: re-init and reveal sections when they re-render or are selected
  if(inDesignMode){
    document.addEventListener('shopify:section:load', function(e){ reveal(e.target); initHero(e.target); initGallery(e.target); });
    document.addEventListener('shopify:section:select', function(e){ reveal(e.target); });
    document.addEventListener('shopify:block:select', function(e){ if(e.target){ reveal(e.target.closest('.shopify-section')||document); } });
  }
})();


document.addEventListener('input', function(event) {
  var search = event.target;
  if (!search.matches('[data-e9-scent-filter]')) return;

  var fieldset = search.closest('.variant-fieldset');
  if (!fieldset) return;

  var term = search.value.trim().toLocaleLowerCase();
  var options = fieldset.querySelectorAll('.opts .opt');
  var matches = 0;

  options.forEach(function(option) {
    var isMatch = option.textContent.toLocaleLowerCase().includes(term);
    option.hidden = !isMatch;
    if (isMatch) matches++;
  });

  var status = fieldset.querySelector('[data-e9-scent-status]');
  if (status) {
    status.textContent = term && matches === 0 ? search.dataset.e9NoResults : '';
  }
});
